import { Component, EventEmitter, Input, Output, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-core-otp',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './core-otp.component.html',
    styleUrl: './core-otp.component.scss'
})
export class CoreOtpComponent {
    @Input() length: number = 6;
    @Output() otpChange = new EventEmitter<string>();
    @Output() otpComplete = new EventEmitter<string>();

    @ViewChildren('otpInput') inputs!: QueryList<ElementRef>;

    otpValues: string[] = [];

    ngOnInit() {
        this.otpValues = new Array(this.length).fill('');
    }

    trackByIndex(index: number, obj: any): any {
        return index;
    }

    onInput(index: number, event: any) {
        let value = event.target.value;

        // Allow only number
        if (!/^\d*$/.test(value)) {
            value = value.replace(/\D/g, '');
            event.target.value = value;
        }

        // Take only the last char if multiple chars entered (except paste which is handled separately)
        if (value.length > 1) {
            value = value.slice(-1);
            event.target.value = value;
        }

        this.otpValues[index] = value;

        // Handle normal input
        if (value.length === 1) {
            if (index < this.length - 1) {
                this.inputs.get(index + 1)?.nativeElement.focus();
            } else {
                this.inputs.get(index)?.nativeElement.blur(); // Optional: blur on last
            }
        }

        this.emitOtp();
    }

    onKeyDown(index: number, event: KeyboardEvent) {
        const input = event.target as HTMLInputElement;

        // Handle Backspace
        if (event.key === 'Backspace') {
            if (!input.value) {
                // If empty, move previous
                if (index > 0) {
                    event.preventDefault(); // Prevent standard backspace behavior to control focus manually
                    const prevInput = this.inputs.get(index - 1)?.nativeElement;
                    prevInput.focus();
                    // Optional: clear previous on backspace move? Standard is just move focus first, then delete on next press.
                    // Or delete and move same time:
                    // this.otpValues[index - 1] = '';
                    // prevInput.value = '';
                    // this.emitOtp();
                }
            } else {
                // If has value, standard backspace clears it (model updates via onInput usually, but here 'input' event might not fire if we prevent default?)
                // Actually standard backspace fires 'input' event with empty value.
                // Let's just update model manually if we want immediate feedback or rely on input event.
            }
        }
    }

    onPaste(event: ClipboardEvent) {
        event.preventDefault();
        const pastedData = event.clipboardData?.getData('text/plain').slice(0, this.length);

        if (pastedData && /^\d+$/.test(pastedData)) {
            pastedData.split('').forEach((char, index) => {
                if (this.otpValues[index] !== undefined) {
                    this.otpValues[index] = char;
                }
            });

            const nextIndex = Math.min(pastedData.length, this.length - 1);
            this.inputs.get(nextIndex)?.nativeElement.focus();
            this.emitOtp();
        }
    }

    emitOtp() {
        const otp = this.otpValues.join('');
        this.otpChange.emit(otp);
        if (otp.length === this.length) {
            this.otpComplete.emit(otp);
        }
    }

    /** Vacía los dígitos y enfoca el primer campo (p. ej. tras cerrar una alerta de error). */
    clear(): void {
        this.otpValues = new Array(this.length).fill('');
        this.emitOtp();
        setTimeout(() => {
            this.inputs?.forEach(ref => {
                (ref.nativeElement as HTMLInputElement).value = '';
            });
            this.inputs?.first?.nativeElement?.focus();
        });
    }
}
